module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/FreeIssue-LetterSantaClous.aff27df3.png";